import React from "react";
import "./Testimonial.css";

const Testimonial = ({ title, testimonials }) => {
  return (
    <div className="testimonial">
      <h2>{title}</h2>
      <div className="testimonial-cards">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            <p>&ldquo;{testimonial.text}&rdquo;</p>
            <h3>- {testimonial.author}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonial;
